import React from 'react';
import {useTranslation} from "react-i18next";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {Helmet} from "react-helmet";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import CloseBottomBar from "../components/core/CloseBottomBar";
import queryString from 'query-string';
import {useNavigate, useLocation, useParams} from "react-router-dom";
import CommunicatorViewCommentsComponents
    from "../components/page-communicator-comment-view/CommunicatorViewCommentsComponents";
import {Button} from "@material-ui/core";
import {COMMUNICATOR_CREATE_COMMENT_PAGE_PATH, HOME_OVERVIEW_PAGE_PATH} from "../layouts/navigation/Navigator";
import { normalizeToString } from '../utils/QueryParamNormalizerUtils';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        }
    })
);

const CommunicatorViewCommentsPage = () => {

    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {uuid, shipmentId} = useParams();
    const location = useLocation();
    const {redirect} = queryString.parse(location.search);

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.communicator")}</title>
                <meta name="description" content={t("page.title.communicator")}/>
            </Helmet>

            <div className={classes.root}>
                <AuthenticatedUserLayout pageTitle={t("page.title.communicator-message-view")}>

                    <CommunicatorViewCommentsComponents/>

                </AuthenticatedUserLayout>
            </div>

            <CloseBottomBar executeClose={() => navigate(normalizeToString(redirect) ?? HOME_OVERVIEW_PAGE_PATH)}>
                <Button variant="contained" color="primary" size="small" onClick={() => {
                    navigate({
                        pathname: [COMMUNICATOR_CREATE_COMMENT_PAGE_PATH, uuid, shipmentId].join("/"),
                        search: `redirect=${encodeURIComponent(location.pathname + location.search)}`
                    })
                }}>
                    {t("buttons.add-comment")}
                </Button>
            </CloseBottomBar>

        </AuthorizedContextProvider>
    )
};

export default CommunicatorViewCommentsPage;